export const _quoteFontFamily = (fontFamily: string) => {
  return fontFamily.startsWith('"') ? fontFamily : `"${fontFamily}"`;
};
